<template>
  <OArticleCard v-bind="$attrs" class="sm:flex rounded-md bg-white overflow-hidden">
    <template #desktop>
      <OArticleCover width="500" class="flex-shrink-0" />

      <div class="flex flex-col pt-5 px-6">
        <OArticleTitle
          class="hover:text-link-primary text-primary-100 leading-24 tracking-tight font-semibold text-xl line-clamp-4"
          link
          overlay
        />
        <OArticleDescription class="text-base leading-24 font-normal text-primary-200 line-clamp-5 mt-2 mb-3" />
        <OArticleHashtag class="leading-22" />
      </div>
    </template>
    <template #mobile>
      <OArticleCover />
      <div class="p-4">
        <OArticleTitle
          class="hover:text-link-primary text-primary-100 leading-24 tracking-tight font-semibold text-lg line-clamp-3"
          link
          overlay
        />
      </div>
    </template>
  </OArticleCard>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import OArticleCard from '~/modules/card/components/ArticleCard';
import OArticleCover from '~/modules/card/components/ArticleCover';
import OArticleTitle from '~/modules/card/components/ArticleTitle';
import OArticleDescription from '~/modules/card/components/ArticleDescription';
import OArticleHashtag from '~/modules/card/components/ArticleHashtag';

export default defineComponent({
  components: {
    OArticleCard,
    OArticleCover,
    OArticleTitle,
    OArticleDescription,
    OArticleHashtag,
  },
  inheritAttrs: false,
});
</script>
